import React from 'react';
import { sanitize } from "../../utils/html";
export var Markup = function Markup(_ref) {
  var text = _ref.text;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/no-danger
    React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: sanitize(text)
      }
    })
  );
};